import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "swiper/swiper-bundle.css";

import "./ClientSwiper.css";
SwiperCore.use([Navigation, Pagination, Autoplay]);
const ClientSwiper = () => {
    const customPrevButton = (
        <IoIosArrowBack size={30} color="#fff" className="swiper-button-prev" />
    );

    const customNextButton = (
        <IoIosArrowForward size={30} color="#fff" className="swiper-button-next" />
    );

    return (
        <Swiper
            navigation={{
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            }}
            pagination={{ clickable: true }}
            loop
            speed={1000}
            autoplay={{ delay: 1000 }} // Set autoplay delay to 1 second
            className="swiper2 p-8 my-4"
        >
            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "אסף היקר תודה רבה על אוכל ביתי וטעים שימחת אותנו מאד נמליץ עליך באהבה שבת שלום מגלית ואהוד אהרוני
                    "
                </p>
                {/* <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    נדיה רצוו
                </p> */}
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "קייטרינג שובע שמחות אתם אלופים
                    בשלתם לי את הסעודת מצווה של אימי ז"ל
                    היה טעים ובשפע
                    תודה על הכל שחר גבריאל כמובן שנחזור להזמין"
                </p>
                {/* <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    נדיה רצוו
                </p> */}
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "קייטרינג שובע שמחות תודה רבה על שבת חתן
                    מושלמת אוכל טעים ושפע ממש כל הכבוד
                    רוני ורבקה ארביב"
                </p>
                {/* <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    נדיה רצוו
                </p> */}
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "אסף מקייטרינג שובע שמחות תודה ענקית על תרומת האוכל לחיילי צבא הגנה
                    לישראל בדרום במיוחד בתקופת המלחמה הזאת. משמיים יתנו לכם בחזרה - דוד
                    רביע והחברים"
                </p>
                {/* <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    נדיה רצוו
                </p> */}
            </SwiperSlide>







            <div className="swiper-button-prev-custom">{customPrevButton}</div>
            <div className="swiper-button-next-custom">{customNextButton}</div>
        </Swiper>
    );
}

export default ClientSwiper